// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__M8wZx","inputDescription":"styles_inputDescription__1Z0zc"};